import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panoramic%20scene%2C%20group%20of%20diverse%20characters%20from%20romance%20fantasy%20and%20action%20genres%2C%20wide%20cinematic%20composition%2C%20warm%20golden%20and%20soft%20amber%20lighting%2C%20dreamy%20atmospheric%20illustration%2C%20horizontal%20layout%2C%20soft%20focus%20background&width=1920&height=800&seq=cta-bg-2026&orientation=landscape"
          alt="韩漫屋 - 开始你的阅读之旅"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="relative">
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 lowercase" style={{ fontFamily: "var(--font-heading)" }}>
            start your journey
          </h2>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-3 px-8 py-3.5 bg-white text-foreground-950 rounded-full text-base font-semibold hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
          >
            <span>开始阅读</span>
            <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </span>
          </Link>
        </div>
        <div className="absolute right-6 md:right-10 bottom-0 max-w-xs">
          <p className="text-base md:text-lg text-white/80 leading-relaxed">
            海量正版韩漫免费读，<br />每天都有新惊喜等你发现
          </p>
        </div>
      </div>
    </section>
  );
}